import customersController from './customersController'

export default customersController



// WEBPACK FOOTER //
// ../src/controllers/customersController/index.js